import React from 'react';
import { EnvironmentProvider } from '../../contexts/EnvironmentContext';

import SellerLocationSection from './components/SellerLocationSection';
import { TListingClient } from 'types/TListing';

type TInspectionServiceAppProps = {
  environment: any;
  appState: {
    listing: TListingClient;
  };
};

const SellerLocationSectionApp = ({ environment, appState }: TInspectionServiceAppProps) => {
  const {
    listing: { seller },
  } = appState;

  return (
    <EnvironmentProvider value={environment}>
      <SellerLocationSection seller={seller} />
    </EnvironmentProvider>
  );
};

export default SellerLocationSectionApp;
